const POSTAL_CODE_REGEX = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

export function cleanPostalCode(postalCode: string) {
    const removedSpaces = postalCode.replace(/\s/g, "");
    return removedSpaces.trim().toUpperCase();
}

export function isValidPostalCode(postalCode: string) {
    return POSTAL_CODE_REGEX.test(postalCode);
}